<script>
import {profileMixin} from '@/mixins/profileMixin'
export default {
  name: 'Stats',
  mixins: [profileMixin],
  data: () => ({
    title: 'Stats'
  }),
  props: {
    'html': {
      type: [Number, String],
      default: 0
    },
    'psd': {
      type: [Number, String],
      default: 0
    },
    'htmlVideo': {
      type: [Number, String],
      default: 0
    },
    'afterEffects': {
      type: [Number, String],
      default: 0
    },
    'htmlCapacity': {
      type: Number,
      default: 0
    },
    'psdCapacity': {
      type: Number,
      default: 0
    },
    'htmlVideoCapacity': {
      type: Number,
      default: 0
    },
    'afterEffectsCapacity': {
      type: Number,
      default: 0
    }
  },
  computed: {
    isAdmin () {
      console.log(this.profileUser.role)
      return this.profileUser && this.profileUser.role === 1
    }
  },
  methods: {
    getCapacityClass (capacity) {
      let className = 'capacity '
      if (capacity < 50) {
        className += 'bg-success'
      } else if (capacity > 50 && capacity < 85) {
        className += 'bg-warning'
      } else if (capacity >= 85) {
        className += 'bg-danger'
      }
      return className
    }
  }
}
</script>

<template>
  <div class="container">
    <h4>
      <span>
        <i class="fa fa-bar-chart"></i>
      </span>
      Renders in Queue:
    </h4>
    <div class="row">
      <div class="card">
        <div class="card-title">
          <span>HTML</span>
          <div :class="getCapacityClass(htmlCapacity)" v-if="isAdmin">Capacity {{ htmlCapacity }}%</div>
        </div>
        <div class="card-body">
          <span class="counter">{{ html }}</span>
        </div>
      </div>
      <div class="card">
        <div class="card-title">
          <span>PSD</span>
          <div :class="getCapacityClass(psdCapacity)" v-if="isAdmin">Capacity {{ psdCapacity }}%</div>
        </div>
        <div class="card-body">
          <span class="counter">{{ psd }}</span>
        </div>
      </div>
      <div class="card">
        <div class="card-title">
          <span>HTML-VIDEO</span>
          <div :class="getCapacityClass(htmlVideoCapacity)" v-if="isAdmin">Capacity {{ htmlVideoCapacity }}%</div>
        </div>
        <div class="card-body">
          <span class="counter">{{ htmlVideo }}</span>
        </div>
      </div>
      <div class="card">
        <div class="card-title">
          <span>AFTER-EFFECTS</span>
          <div :class="getCapacityClass(afterEffectsCapacity)" v-if="isAdmin">Capacity {{ afterEffectsCapacity }}%</div>
        </div>
        <div class="card-body">
          <span class="counter">{{ afterEffects }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.container {
  width: 100%;
  background-color: #f5f5f5;
  margin: 10px auto auto;
  padding: 5px 10px 40px 10px;
  border: 0.5px solid #c2bdbd;
  border-radius: 2px;
}
.row {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.card {
  background-color: #2c3247;
  min-width: 20vw;
  min-height: 10vh;
  border: 1px solid;
  padding: 10px;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.card-title {
  display: flex;
  font-weight: bold;
  font-size: large;
  color: #FFFFFF;
  justify-content: space-between;
}
.card-body {
  margin-top: 20px;
  background-color: #FFFFFF;
  border-radius: 2px;
}
.counter {
  color: #37882d;
  font-size: xx-large;
  padding: 5px;
  float: right;
}
h4 {
  color: #337ab7;
  padding-bottom: 5px;
  margin-bottom: 20px;
  border-bottom: 0.5px solid #c2bdbd;
}
.capacity {
  display: flex;
  align-items: center;
  font-size: small;
  border-radius: 2px;
  padding: 0 5px 1px 5px;
  margin: 0;
}
.bg-success {
  background-color: #14A44D;
}
.bg-warning {
  background-color: #E4A11B;
}
.bg-danger {
  background-color: #dc3545;
}
</style>



// WEBPACK FOOTER //
// src/components/RenderManager/stats.vue